export enum SurveyActionConditionTypeEnum {
    QuestionIsEqualToAnswer,
    QuestionIsNOTEqualToAnswer
}